/* martin-lookup.js
   Simple Martin serial → year lookup (Style B UX)
   Targets:
     - #martin-serial-input
     - #martinLookupBtn
     - #martin-lookup-result
*/

(function(){
  'use strict';

  // Year → lastSerial mapping (from your table)
  const yearLast = [
    {year:1898, last:8348},{year:1899, last:8716},{year:1900, last:9128},{year:1901, last:9310},
    {year:1902, last:9528},{year:1903, last:9810},{year:1904, last:9988},{year:1905, last:10120},
    {year:1906, last:10329},{year:1907, last:10727},{year:1908, last:10883},{year:1909, last:11018},
    {year:1910, last:11203},{year:1911, last:11413},{year:1912, last:11565},{year:1913, last:11821},
    {year:1914, last:12047},{year:1915, last:12209},{year:1916, last:12390},{year:1917, last:12988},
    {year:1918, last:13450},{year:1919, last:14512},{year:1920, last:15848},
    {year:1921, last:16758},{year:1922, last:17839},{year:1923, last:19891},{year:1924, last:22008},
    {year:1925, last:24116},{year:1926, last:28689},{year:1927, last:34435},{year:1928, last:37568},
    {year:1929, last:40843},{year:1930, last:45317},{year:1931, last:49589},{year:1932, last:52590},
    {year:1933, last:55084},{year:1934, last:58679},{year:1935, last:61947},{year:1936, last:65176},
    {year:1937, last:68865},{year:1938, last:71866},{year:1939, last:74061},{year:1940, last:76734},
    {year:1941, last:80013},{year:1942, last:83107},{year:1943, last:86724},{year:1944, last:90149},
    {year:1945, last:93623},{year:1946, last:98158},{year:1947, last:103468},{year:1948, last:108269},
    {year:1949, last:112961},{year:1950, last:117961},{year:1951, last:122799},{year:1952, last:128436},
    {year:1953, last:134501},{year:1954, last:141345},{year:1955, last:147328},{year:1956, last:153225},
    {year:1957, last:159061},{year:1958, last:165576},{year:1959, last:171047},{year:1960, last:175689},
    {year:1961, last:181297},{year:1962, last:187384},{year:1963, last:193327},{year:1964, last:199626},
    {year:1965, last:207030},{year:1966, last:217215},{year:1967, last:230095},{year:1968, last:241925},
    {year:1969, last:256003},{year:1970, last:271633},{year:1971, last:294270},{year:1972, last:313302},
    {year:1973, last:333873},{year:1974, last:353387},{year:1975, last:371828},{year:1976, last:388800},
    {year:1977, last:399625},{year:1978, last:407800},{year:1979, last:419900},{year:1980, last:430300}
  ];

  function safeHTML(s){ return (s==null) ? '' : String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function normalize(sn){ return (sn||'').toString().replace(/[^0-9]/g,'').trim(); }

  function findYearForSerial(n){
    if(n > yearLast[yearLast.length-1].last) return {year:null, note:'Serial is higher than our 1980 table — likely 1981 or later.'};
    for(let i=0;i<yearLast.length;i++){
      if(n <= yearLast[i].last){
        return {year: yearLast[i].year, last: yearLast[i].last};
      }
    }
    return {year:null, note:'Not found in table.'};
  }

  // UI hookup
  document.addEventListener('DOMContentLoaded', function(){
    const input = document.getElementById('martin-serial-input');
    const btn = document.getElementById('martinLookupBtn');
    const out = document.getElementById('martin-lookup-result');

    function renderResult(obj){
      out.style.display = 'block';
      out.innerHTML = obj.html;
      // wire details toggle (if present)
      const toggle = out.querySelector('.martin-details-toggle');
      const collapse = out.querySelector('#martin-collapse');
      if(toggle && collapse){
        toggle.addEventListener('click', function(){
          const open = collapse.classList.toggle('open');
          toggle.textContent = open ? 'Hide details' : 'Show details';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    }

    function buildHTML(candidates){
      if(!candidates || candidates.length===0) return '<div><strong>No result</strong></div>';
      const best = candidates[0];
      let html = '<div class="martin-compact">';
      html += `<div><div class="martin-best">${safeHTML(best.label)}</div><div style="color:rgba(0,0,0,0.7); margin-top:6px;">${safeHTML(best.why)}</div></div>`;
      html += `<div><span class="martin-badge">${safeHTML(best.confidence)}</span></div>`;
      html += '</div>';
      html += `<div id="martin-collapse" class="martin-collapse">`;
      html += `<div style="margin-top:10px;"><strong>How to confirm</strong><ul style="margin:8px 0 0 18px;"><li>Check the printed label inside the sound hole for model and factory info.</li><li>Compare construction details (top bracing, dovetail) to era references.</li><li>When in doubt, send photos and we’ll verify.</li></ul></div>`;
      html += '</div>';
      return html;
    }

    function run(){
      if(!input || !out) return;
      const raw = input.value || '';
      const serial = normalize(raw);
      if(!serial){
        renderResult({html:'<div style="color:#b00"><strong>Please enter a numeric Martin serial.</strong></div>'});
        return;
      }
      const n = parseInt(serial,10);
      if(isNaN(n)){
        renderResult({html:'<div style="color:#b00"><strong>Invalid serial — please enter only digits.</strong></div>'});
        return;
      }

      const found = findYearForSerial(n);
      const candidates = [];
      if(found.year){
        candidates.push({
          label: `Approx year: ${found.year}`,
          confidence: 'HIGH',
          why: `Serial ${n} is ≤ ${found.last} (published last-serial for ${found.year}).`
        });
      } else {
        candidates.push({
          label: 'Post-1980 or not in table',
          confidence: 'LOW',
          why: found.note
        });
      }

      const html = buildHTML(candidates);
      renderResult({html: html});
    }

    if(!input || !btn || !out){
      console.error('Martin lookup: missing UI elements (martin-serial-input, martinLookupBtn, martin-lookup-result).');
      return;
    }

    // Enter key
    input.addEventListener('keydown', function(ev){ if(ev.key === 'Enter'){ ev.preventDefault(); run(); }});
    btn.addEventListener('click', run);

    // expose simple debug
    window.__gpg_martin_lookup = { run: run, findYearForSerial: findYearForSerial };
  });
})();
